module.exports = __webpack_public_path__ + "static/media/DSC_2325.4704b53d.jpg";